export default {
    subtotal: {
        title:  'Subtotal',
    },
    tax: {
        title: 'Tax',
    },
    shipping: {
        title: 'Shipping',
    },
    coupons: {
        title: 'Coupons',
    },
    loyalty: {
        title: 'Cookie Dough',
    },
    rewardRedemption: {
        title: 'Reward Redemption',
    },
    tip: {
        title: 'Tip',
    },
    total: {
        title: 'Total',
    },
    delivery: {
        title: 'Delivery'
    },
    extendedDelivery: {
        title: 'Extended Delivery'
    },
    serviceFee: {
        title: 'Service Fee',
    },
    deliveryFeeDiscount: {
        title: 'Delivery Fee Discount',
    },
}
